import { Heart, Pattern2, Pattern3, Pattern4 } from "@/(front-desk)/utils/patterns"
import classNames from "classnames"

export default function Badges(props) {

    const { className, awards, pending, collapse } = props
    const needCollapse = collapse && awards?.length > 0

    if (awards?.length > 0) return (
        <div className={`badges ${className}`}>
            { (needCollapse ? [awards[0]] : awards).map((award, index) => {
                const shortcut = award.award_type.shortcut
                const category = award.award_type?.category?.shortcut
                return (
                    <div
                        key={`award-${shortcut}-${index}`}
                        className={classNames('item', {
                            'item-nominee': shortcut.includes('nominee'),
                            '!bg-black-700': shortcut === 'final-nominee',
                            'item-main': ['selected', 'top-school', 'judge-special'].includes(shortcut) ||
                                (shortcut.includes('best') && category !== 'AN'),
                            'item-bronze': shortcut === 'bronze',
                            'item-silver': shortcut === 'silver' || (shortcut.includes('best') && category === 'AN'),
                            'item-gold': ['gold', 'best-animation', 'fan-favorite'].includes(shortcut),
                            'item-fan': shortcut === 'fan-favorite',
                        })}
                        style={{order: 10 - award.award_type.weight}}
                    >
                        <Pattern2 className="pattern-2" />
                        <Pattern3 className="pattern-3" />
                        <Pattern4 className="pattern-4" />
                        <Heart className="pattern-heart !w-3" />
                        {award.award_type.name}
                    </div>
                )
            })}
            { collapse && awards.length > 1 &&
                <div className="item bg-black !rounded-full !border-none order-[99]">
                    + {awards.length - 1}
                </div>
            }
        </div>
    )
    else if (pending) return (
        <div className={`badges ${className}`}>
            <div className="item item-default">等待審核中</div>
        </div>
    )
    else return null
}